document.addEventListener('DOMContentLoaded', function () {
  function syncThumbnailHeight() {
    document.querySelectorAll('.thumbnail-slider').forEach(function (slider) {
      const list = slider.querySelector('.thumbnail-list');
      const mediaGallery = slider.closest('media-gallery');
      if (!list || !mediaGallery) return;

      const mainSlide = mediaGallery.querySelector('slider-component:not(.thumbnail-slider)');
      if (!mainSlide) return;

      const totalHeight = mainSlide.getBoundingClientRect().height;
      const prevBtn = slider.querySelector('.slider-button--prev');
      const nextBtn = slider.querySelector('.slider-button--next');
      const btnHeight = (prevBtn ? prevBtn.offsetHeight : 0) + (nextBtn ? nextBtn.offsetHeight : 0);
      const available = Math.max(totalHeight - btnHeight - 16, 100);

      list.style.maxHeight = available + 'px';
    });
  }

  setTimeout(syncThumbnailHeight, 200);
  window.addEventListener('resize', syncThumbnailHeight);
  window.addEventListener('load', syncThumbnailHeight);
  document.querySelectorAll('media-gallery slider-component:not(.thumbnail-slider)').forEach(function (el) {
    new ResizeObserver(syncThumbnailHeight).observe(el);
  });

  document.querySelectorAll('.product--thumbnail .thumbnail-slider, .product--thumbnail_slider .thumbnail-slider').forEach(function (slider) {
    const list = slider.querySelector('.thumbnail-list');
    const prevBtn = slider.querySelector('.slider-button--prev');
    const nextBtn = slider.querySelector('.slider-button--next');
    if (!list) return;

    function getThumbButtons() {
      return Array.from(list.querySelectorAll('.thumbnail'));
    }

    function getActiveIndex(buttons) {
      const idx = buttons.findIndex(b => b.getAttribute('aria-current') === 'true');
      return idx === -1 ? 0 : idx;
    }

    function goTo(step) {
      const buttons = getThumbButtons();
      if (!buttons.length) return;
      let idx = getActiveIndex(buttons) + step;
      if (idx < 0) idx = buttons.length - 1;
      if (idx >= buttons.length) idx = 0;
      buttons[idx].click(); // Dawn ka built-in click handler yehi hai jo main image switch karta hai
      buttons[idx].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function keepEnabled(btn) {
      if (!btn) return;
      btn.removeAttribute('disabled');
      new MutationObserver(function () {
        if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
      }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });
    }
    keepEnabled(prevBtn);
    keepEnabled(nextBtn);

    if (prevBtn) {
      prevBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(1);
      });
    }
  });
});